const ua = window.navigator.userAgent;

const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");

export const isIE = msie > 0 || msie11 > 0;
export const isEdge = msedge > 0;
export const isIEOrEdge = isIE || isEdge;
